import CreateTemplatePage from './CreateTemplatePage';

export default CreateTemplatePage;
